// Alice conversation topic types.
//
// These live in lib/ rather than alongside the conversations selectors because
// they are plain constants with no Redux involvement. Both this file and
// reduxToolkit/conversationsSelectors.ts (which re-exports them so existing
// import paths keep working) now live in @healthshare/shared -- see
// docs/plans/embeddable-sdk.md Phase 1 / docs/plans/native-app-sdk-seams.md
// Stage 1.

export const ALICE_TOPIC_TYPE = 'alice-chat'
export const ALICE_PROVIDER_TOPIC_TYPE = 'alice-provider-chat'

// Topic types whose inbound messages Alice answers.  Mirrors
// AliceConversationProcessor::ALICE_TOPIC_TYPES on the backend.
export const ALICE_ANSWERED_TOPIC_TYPES: ReadonlySet<string> = new Set([
  ALICE_TOPIC_TYPE,
  ALICE_PROVIDER_TOPIC_TYPE,
])

// The topic types under which a provider is asked for an itemized bill. Both key
// `topic_ref_id` on the INCIDENT, and the backend picks between them by feature flag:
// RequestItemizedBillsJob:116 uses `alice-provider-chat` for an organization with Alice
// and `itemized-bill` otherwise, while AiEmailConversationMatcher:187 resolves
// `topic_ref_id` as an incident for both. findItemizedBillConversation has to match the
// same pair, or an Alice organization's thread is invisible to the expense that owns it.
export const ITEMIZED_BILL_TOPIC_TYPES: ReadonlySet<string> = new Set([
  'itemized-bill',
  ALICE_PROVIDER_TOPIC_TYPE,
])
